import { AffiliateUrls, Image, Link } from "@customTypes/index";
import { AffiliateLinksCopy, PresentationFields } from "@lib/constants";
import { Button, Col, Divider, Row, Space } from "antd";


interface IssueCoverArtCardProps {
  className?: string;
  title?: string;
  date?: string;
  imgRatio?: string;
  description?: string;
  link?: Link;
  image?: Image;
  showFields?: string[];
  layout?: number[];
  affiliateUrls?: AffiliateUrls;
}

const defaultProps: IssueCoverArtCardProps = {};

const IssueCoverArtCard = ({
  className, title, date, description,
  link, image, imgRatio, showFields, layout,
  affiliateUrls,
}: IssueCoverArtCardProps) => {
  const [left, right] = layout ?? [24, 24];

  return (
    <Row gutter={[10, 10]}
      className={`covr-cta-coverart-card ${className}`}
    >
      <Col span={left} className="top">
        {showFields?.includes(PresentationFields.ISSUE)
          ? <a target={link?.target} href={link?.url}>
            <img
              className="responsive-img"
              src={image?.src}
              alt={image?.alt}
              title={`Go to : ${title}`}
              loading="lazy"
            />
          </a>
          : <img
            className="responsive-img"
            src={image?.src}
            alt={image?.alt}
            title={`Go to : ${title}`}
            loading="lazy"
          />
        }
      </Col>
      <Col span={right} className="bottom">
        {showFields?.includes(PresentationFields.DATE)
          && <h4 className="date" title={date}>{date}</h4>}
        {showFields?.includes(PresentationFields.TITLE)
          && <h3 className="title ellipsis line-clamp-2" title={title}>{title}</h3>}
        {showFields?.includes(PresentationFields.DESCRIPTION)
          && description
          && <p className="description" title={description}>{description}</p>}
        <Space className={`covr-affiliate-links`} wrap size={0}>
          {showFields?.includes(PresentationFields.EBAY)
            && <Button
              className={`btn`}
              href={affiliateUrls?.ebayUrl}
              target={`_blank`}
              type="link"
              size="small"
            >
              {AffiliateLinksCopy.EBAY}
            </Button>
          }

          {showFields?.includes(PresentationFields.EBAY)
            && (showFields?.includes(PresentationFields.MY_COMIC_SHOP) || showFields?.includes(PresentationFields.THIRD_EYE)) 
            && <Divider type={`vertical`} />}

          {showFields?.includes(PresentationFields.MY_COMIC_SHOP)
            &&
            <Button
              className={`btn`}
              href={affiliateUrls?.mycomicshopUrl}
              target={`_blank`}
              type="link"
              size="small"
            >
              {AffiliateLinksCopy.MCS}
            </Button>
          }

          {(showFields?.includes(PresentationFields.EBAY) || showFields?.includes(PresentationFields.MY_COMIC_SHOP))
            && showFields?.includes(PresentationFields.THIRD_EYE)
            && <Divider type={`vertical`} />}

          {showFields?.includes(PresentationFields.THIRD_EYE)
            && <Button
              className={`btn affiliate-link-third_eye`}
              href={affiliateUrls?.thirdEyeUrl}
              target={`_blank`}
              type="link"
              size="small"
            >
              {AffiliateLinksCopy.THIRD_EYE}
            </Button>
          }
          {(showFields?.includes(PresentationFields.MY_COMIC_SHOP) || showFields?.includes(PresentationFields.EBAY) || showFields?.includes(PresentationFields.THIRD_EYE)) && 
          <p className="covr-affiliate-disclosure">Affiliate disclosure: This site contains affiliate links for which we may be compensated.</p>}
        </Space>
      </Col>
    </Row>
  );
};

IssueCoverArtCard.defaultProps = defaultProps;

export default IssueCoverArtCard;
